import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useDispatch } from "react-redux";
import { toastAlert } from "../../lib/toastAlert";
import { MatEditor } from "maticzeditor"
import { addfaq } from '../../actions/users';
import isEmpty from '../../lib/isEmpty';
import { useNavigate } from 'react-router-dom';

const FAQAdd = () => {
    const navigate = useNavigate()
    const [validateError, setValidateError] = useState({});
    const [categoryname, setCategoryname] = useState('');
    const [question, setquestion] = useState("");
    const [answer, setanswer] = useState("");

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        var type = categoryname.categoryname;
        let reqData = {
            question,
            answer

        }
        let { error } = await addfaq(reqData);
        if (isEmpty(error)) {
            toastAlert("success", 'Faq added successfully');
            navigate('/faqlist')
        } else {
            setValidateError(error);
        }
    }

    const onChange = (e) => {
        setquestion(e.target.value)
    }

    const onEditorChange = (evt) => {
        var description_text = evt
        setanswer(description_text);
    }

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Add FAQ'} />
                        <div className='common_page_scroller mt-5 pe-2'>
                        <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>

                            <form noValidate onSubmit={handleFormSubmit} autoComplete="off">
                                <div className="addcategorys">
                                    <h4>Add Faq</h4>
                                    <p className='mb-0'>Create a new Faq</p>
                                </div>


                                <div className="categorylisdt">
                                <div className='row'>
                                <div className='col-xl-7 mt-3'>
                                        <label className='mb-2'>Question</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            id="question"
                                            value={question || ''}
                                            onChange={onChange}
                                            fullWidth
                                        />
                                        {validateError.question && (
                                            <span className="text-danger">{validateError.question}</span>
                                        )}
                                    </div>
                               
                              
                                    <div className='col-xl-7 mt-3'>
                                        <label className='mb-2'>Answer</label>
                                        <MatEditor sendata={answer} outdata={(evt) => onEditorChange(evt)} />
                                        {validateError.answer && (
                                            <span className="text-danger">{validateError.answer}</span>
                                        )}
                                    </div>
                                  
                                </div>
                                </div>
                                <div>
                                    <button className='btn addcate mt-4 ms-2' type="button">Add</button>
                                </div>
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default FAQAdd